import { ColumnSelectLabel } from "@common/facet";
import { BaseTableColumnsHelper } from "../../../../common/util/table-columns/base-table-columns-helper";
import { Injectable } from "@angular/core";

@Injectable()
export class TasksScheduleTableColumnsHelper extends BaseTableColumnsHelper {
    constructor() {
        const visibleColumns = {
            protocol: true,
            taskAlias: true,
            dueDate: true,
            startTime: true,
            duration: true,
            endTime: true,
            assignedTo: true,
            location: true,
            deviation: true,
            status: true,
        };

        super(visibleColumns);
    }

    protected setupColumnSelectLabels(): void {
        this.columnSelectLabels = [
            new ColumnSelectLabel('protocol', 'Protocol'),
            new ColumnSelectLabel('taskAlias', 'Task'),
            new ColumnSelectLabel('dueDate', 'Due Date'),
            new ColumnSelectLabel('startTime', 'Start Time'),
            new ColumnSelectLabel('duration', 'Duration'),
            new ColumnSelectLabel('endTime', 'End Time'),
            new ColumnSelectLabel('assignedTo', 'Assigned To'),
            new ColumnSelectLabel('location', 'Location'),
            new ColumnSelectLabel('deviation', 'Allowance'),
            new ColumnSelectLabel('status', 'Progress'),
        ];
    }
}